import { tagKey, tagsKey } from './keys'
import { useQueryClient } from '@tanstack/react-query'
import { type TagData, Logger, type TagListInput, type TagId } from '@terros/common'

const logger = new Logger('useTagCache')
logger.level = 'verbose'

export const useTagCache = () => {
  const queryClient = useQueryClient()
  return {
    setList: (data: TagData[], input?: TagListInput) => {
      logger.verbose('setList tags')
      queryClient.setQueryData(tagsKey(input), data)
    },
    clearList: () => {
      logger.verbose('invalidateQueries tagsKey')
      queryClient.invalidateQueries({ queryKey: tagsKey() })
    },
    addItem: (tagData: TagData) => {
      logger.verbose(`addItem tag ${tagData.tagId}`)
      queryClient.setQueryData(tagKey(tagData.tagId), tagData)
    },
    replaceItem: (tagData: TagData) => {
      logger.verbose('replaceItem tag', tagData.tagId)
      queryClient.setQueryData(tagKey(tagData.tagId), tagData)
    },
    removeItem: (tagId: TagId) => {
      logger.verbose('removeItem tag', tagId)
      queryClient.removeQueries({ queryKey: tagKey(tagId) })
    },
  }
}
